module.exports = __webpack_public_path__ + "img/photo-19.165fcc20.jpg";